import { Modal, Button } from 'antd';
import HeadingTypography from 'src/app/components/shared/Typography/Heading';
import { IGuarantor } from '@rasayi-workspace/shared';
import TextTypography from '../../shared/Typography/Text';
import { useMemo } from 'react';
import EditIcon from 'src/assets/icons/editIcone';
import { DocumentsUpload } from '../../shared';

interface IGuarantorDetailModal {
    visible: boolean;
    onClose: () => void;
    guarantor: IGuarantor;
    setGuarantorEditShowModal: (data: boolean) => void;
}

export const GuarantorDetailModal = ({ visible, onClose, guarantor, setGuarantorEditShowModal }: IGuarantorDetailModal) => {
    const guarantorData = useMemo(() => {
        return {
            'First name': guarantor?.first_name ?? 'N/A',
            'Last name': guarantor?.last_name ?? 'N/A',
            CNIC: guarantor?.cnic_number ?? 'N/A',
            Email: guarantor?.email ?? 'N/A',
            'Phone Number': guarantor?.primary_mobile ?? 'N/A',
            'Secondary phone': guarantor?.secondary_mobile ?? 'N/A',
            Province: guarantor?.province ?? 'N/A',
            City: guarantor?.city ?? 'N/A',
        };
    }, [guarantor]);

    return (
        <Modal open={visible ? true : false} onCancel={onClose} footer={null} centered width={1000} className="p-6">
            <div className="flex mb-4 justify-between mt-5">
                <HeadingTypography classNames=" font-semibold text-[#2E2A2A]" fontSize={22}>
                    Guarantor
                </HeadingTypography>
                <div
                    onClick={() => {
                        setGuarantorEditShowModal(true);
                    }}
                    className="text-[#007AFF] cursor-pointer"
                >
                    Edit <EditIcon />
                </div>
            </div>

            <div className="w-[100%]">
                <div className="mb-4 mt-5">
                    <div className="grid grid-cols-2 gap-4">
                        {Object.entries(guarantorData).map(([key, value], index) => (
                            <DataRow key={key + index} title={key} value={value} index={index} />
                        ))}
                    </div>
                </div>

                {/* Documents */}
                <div className="mb-4">
                    <div
                        style={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(3, 1fr)',
                            gap: '16px',
                            maxWidth: '100%',
                            overflowX: 'hidden',
                        }}
                    >
                        <DocumentsUpload
                            title="Profile Picture"
                            maxFiles={3}
                            uploadFiles={() => {}}
                            uploadedFiles={guarantor.documents.find(document => document.name === 'cnic')?.files}
                            leadId={''}
                            isUploadAble={false}
                        />
                        <DocumentsUpload
                            title="CNIC"
                            maxFiles={3}
                            uploadFiles={() => {}}
                            uploadedFiles={guarantor.documents.find(document => document.name === 'bills')?.files}
                            leadId={''}
                            isUploadAble={false}
                        />
                        <DocumentsUpload
                            title="Bank Statement"
                            maxFiles={3}
                            uploadFiles={() => {}}
                            uploadedFiles={guarantor.documents.find(document => document.name === 'cheque')?.files}
                            leadId={''}
                            isUploadAble={false}
                        />

                        <div style={{ gridColumn: 'span 3' }}>
                            <DocumentsUpload
                                title="Utility Bills"
                                maxFiles={11}
                                uploadFiles={() => {}}
                                uploadedFiles={guarantor.documents.find(document => document.name === 'others')?.files}
                                leadId={''}
                                isUploadAble={false}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className="flex justify-end mt-4 gap-2">
                <Button onClick={onClose} className="mr-2 text-red-700 border-red-700 bg-white hover:bg-red-700 !hover:text-white !hover:border-white transition-colors">
                    Cancel
                </Button>
            </div>
        </Modal>
    );
};

const DataRow = ({ title, value, index }: { title: string; value: string; index: number }) => {
    return (
        <div className="flex justify-between">
            <TextTypography classNames="font-normal" fontSize={16}>
                {title}
            </TextTypography>
            <div className="flex">
                <TextTypography classNames="font-medium " fontSize={16}>
                    {value}
                </TextTypography>
                {!(index % 2) ? <div className="w-[1px] h-[70%] bg-[#DBD7D7] mt-[5px] ml-2"></div> : null}
            </div>
        </div>
    );
};
